import PropTypes from 'prop-types';

import Asset from '../Asset';
import { Point } from '../header/header.types';
import { pointPropTypes } from '../../../common/point.propTypes';
import { withCssModulesClassNames } from '../../../common/nextMigrationHelpers';
import { default as styles } from '../../../scss/components/Card.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

interface CardPointsProps {
  points?: Point[];
  isPointCarousel?: boolean;
}

const CardPoints = ({ points, isPointCarousel }: CardPointsProps) => {
  if (points?.length && !isPointCarousel) {
    return (
      <div className={withCssModulesClassNamesHandler('card__points')}>
        {points.map(({
          id,
          header,
          subHeader,
          copy,
          icon,
          images,
        }, i) => (
          <div
            key={`${id}-${i}`}
            data-testid={header}
            className={withCssModulesClassNamesHandler('card__point')}
          >
            {(icon || images?.[0]) && (
              <Asset
                imageClassName={withCssModulesClassNamesHandler('card__point-image')}
                asset={icon || images?.[0]}
              />
            )}
            {header && (
              <strong
                className={withCssModulesClassNamesHandler('card__point-header')}
              >
                {header}
              </strong>
            )}
            {subHeader && (
              <p className={withCssModulesClassNamesHandler('card__point-subheader')}>
                {subHeader}
              </p>
            )}
            {copy && (
              <p className={withCssModulesClassNamesHandler('card__point-copy')}>
                {copy}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  }

  return null;
};

CardPoints.defaultProps = {
  points: [],
  isPointCarousel: false,
};

CardPoints.propTypes = {
  isPointCarousel: PropTypes.bool,
  points: PropTypes.arrayOf(PropTypes.shape(pointPropTypes)),
};

export default CardPoints;
